export const MEDICAL_RECORD_REQUEST_OPEN = 'OPEN';
export const MEDICAL_RECORD_REQUEST_COMPLETE = 'COMPLETE';
export const MEDICAL_RECORD_REQUEST_INACTIVE = 'INACTIVE';
